import { render, staticRenderFns } from "./SearchMessageItem.vue?vue&type=template&id=4a3b80f0&scoped=true&"
import script from "./SearchMessageItem.vue?vue&type=script&lang=js&"
export * from "./SearchMessageItem.vue?vue&type=script&lang=js&"
import style0 from "./SearchMessageItem.vue?vue&type=style&index=0&id=4a3b80f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a3b80f0",
  null
  
)

export default component.exports